import React from 'react';
import CommandItemTable from '../CommandList';

function YouTubeCommand({ onCommandChange, onAddCommand }) {

    const commandItems = [
        { command: 'keyword', description: 'youtube_or_description', type: 'text' },
        { command: 'OR', description: 'youtube_or_description', type: 'text', value: 'OR', readonly: true },
        { command: '-', description: 'youtube_except_description', type: 'text' },
        { command: 'allintitle:', description: 'youtube_allintitle_description', type: 'text' },
        { command: 'before:', description: 'youtube_before_description', type: 'date' },
        { command: 'after:', description: 'youtube_after_description', type: 'date' }
    ];

    return <CommandItemTable commandItems={commandItems} onCommandChange={onCommandChange} onAddCommand={onAddCommand} />
}

export default YouTubeCommand;
